var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { Step } from '@shared/claim/steps';
import { CURRENT_CLAIM_TYPE_LAYOUT_COLOR } from '@shared/layout/layout';
import TitleImageDescriptionLayout from '@declaration/components/TitleImageDescriptionLayout.vue';
import { quitClaimDeclarationCloseCallback } from '@declaration/helpers/layoutMetaCallback';
import { ClaimTypeTrigram } from '@shared/types/api/claim';
const claim = namespace('claim');
const contract = namespace('contract');
const qualification = namespace('qualification');
let OnlyYourDamages = class OnlyYourDamages extends Vue {
    constructor() {
        super(...arguments);
        this.illustration = require('@declaration/assets/images/documents/pause-parcours.svg');
        this.isUpdatingClaim = false;
    }
    get description() {
        return this.isTenant
            ? this.$tc('only_your_damages.description.tenant')
            : this.$tc('only_your_damages.description.owner');
    }
    async save() {
        this.isUpdatingClaim = true;
        await this.updateAndSaveClaim({
            step: this.typeTrigram === ClaimTypeTrigram.StormSnowHail
                ? Step.BeCalledConfirmationTNG
                : Step.YourDamages,
            claimPayload: {},
        });
        this.isUpdatingClaim = false;
    }
};
__decorate([
    claim.Action('updateAndSaveClaim')
], OnlyYourDamages.prototype, "updateAndSaveClaim", void 0);
__decorate([
    contract.Getter('isTenant')
], OnlyYourDamages.prototype, "isTenant", void 0);
__decorate([
    qualification.State('typeTrigram')
], OnlyYourDamages.prototype, "typeTrigram", void 0);
OnlyYourDamages = __decorate([
    Component({
        components: {
            TitleImageDescriptionLayout,
        },
        meta: {
            title: 'page.title.confirmation',
            color: CURRENT_CLAIM_TYPE_LAYOUT_COLOR,
            close: quitClaimDeclarationCloseCallback,
            goBack: null,
        },
    })
], OnlyYourDamages);
export default OnlyYourDamages;
